import { Button, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { ToastError, ToastSuccess } from "../toaster/toast.utils";
import DefaultModal from "./DefaultModal";

export interface ForgotResult {
  newPassword?: string;
}
interface Props {
  open: boolean;
  onClose: () => void;
  initialStep: number;
  process: string;
  onComplete: (result: ForgotResult) => void;
  currentEmail?: string;
}

const ForgotPasswordModal: React.FC<Props> = ({
  open,
  onClose,
  initialStep,
  process = null,
  currentEmail = null,
  onComplete
}) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // const [snackbarOpen, setSnackbarOpen] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
  //   "success"
  // );

  // const openSnackbar = (message: string, severity: "success" | "error") => {
  //   setSnackbarMessage(message);
  //   setSnackbarSeverity(severity);
  //   setSnackbarOpen(true);
  // };

  const handleSendCode = async () => {
    console.log("1");
    try {
      const resProcess = await api.get(`/user/check-process`, {
        params: { email }
      });

      if (resProcess.data) {
        await api.post(`/user/recover-code`, null, { params: { email } });
        setStep(2);
      } else {
        ToastSuccess(
          "Você solicitou um código recentemente. Verifique seu email"
        );
        setStep(2);
      }
    } catch (error: any) {
      if (error.response && error.response.status === 403) {
        ToastError(
          "Este recurso está indisponível no momento. Tente novamente mais tarde"
        );
      } else {
        ToastError(`Erro ao enviar o código: ${error.message}`);
      }
    }
  };

  const handleVerifyCode = async () => {
    console.log("2");
    try {
      const res = await api.get(`/user/check-code`, {
        params: { email, code, process }
      });
      if (res.data === true) setStep(3);
      else throw new Error();
    } catch {
      ToastError("Código inválido.");
    }
  };

  const handleResetPassword = async () => {
    console.log("3");
    if (password !== confirmPassword) {
      return ToastError("As senhas não coincidem.");
    }

    try {
      await api.post(`/user/resetPass`, null, {
        params: { code, password, email, process }
      });
      onComplete({ newPassword: password });
      ToastSuccess("Senha redefinida com sucesso!");
      onClose();
    } catch {
      ToastError("Erro ao redefinir senha.");
    }
  };

  useEffect(() => {
    if (initialStep) {
      setStep(initialStep);
      if (currentEmail) {
        setEmail(currentEmail);
      }
    }
  }, [initialStep]);

  useEffect(() => {
    if (open) {
      setStep(1);
      setEmail("");
      setCode("");
      setPassword("");
      setConfirmPassword("");
      setEmail(currentEmail || "");
    }
  }, [open]);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <TextField
              label="E-mail"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Button fullWidth variant="contained" onClick={handleSendCode}>
              Enviar Código
            </Button>
          </>
        );
      case 2:
        return (
          <>
            <TextField
              label="Código"
              fullWidth
              value={code}
              onChange={(e) => setCode(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Button fullWidth variant="contained" onClick={handleVerifyCode}>
              Validar Código
            </Button>
          </>
        );
      case 3:
        return (
          <>
            <TextField
              label="Nova senha"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Confirmar senha"
              type="password"
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Button fullWidth variant="contained" onClick={handleResetPassword}>
              Redefinir Senha
            </Button>
          </>
        );
    }
  };

  return (
    <DefaultModal
      open={open}
      onClose={onClose}
      title="Recuperação de Senha"
      // snackbarOpen={snackbarOpen}
      // snackbarMessage={snackbarMessage}
      // snackbarSeverity={snackbarSeverity}
      // onSnackbarClose={() => setSnackbarOpen(false)}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        {step === 1 &&
          "Digite seu e-mail para receber o código de recuperação."}
        {step === 2 && "Digite o código enviado ao seu e-mail."}
        {step === 3 && "Digite a nova senha e confirme abaixo."}
      </Typography>
      {renderStep()}
    </DefaultModal>
  );
};

export default ForgotPasswordModal;
